import type { StaticLayerPayload } from "@config";
import {
  AcceptButtonLibrary,
  AcceptButtonLibraryPdf,
} from "@library-elements/accept-button";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: AcceptButtonLibrary,
  pdf: AcceptButtonLibraryPdf,
};

export const AcceptButton = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
